/**
 * VEOS session endpoints of the extranet (fiche 22063 — login).
 *
 * - `boby-ws2-ea-def-sessions` (`WS2_EA_DEF_SESSIONS`): the sessions a
 *   SUPERVUE user may open — possibly thousands, filtered client-side.
 * - `boby-ws2-ea-def-login` (`WS2_EA_DEF_LOGIN`): the post-login control row;
 *   re-run under a new `SES` (sent as `X-Erp-Session-Id` by the spoof
 *   interceptor) when the user switches session, it returns the person of
 *   that session (`*_PER_SESSION`).
 */

import { fetchErpRecord, fetchErpRows } from './erpProxy';
import type { ErpSession, ExtranetPerson } from '../auth/types';

/** Endpoint slugs (contract §6). */
export const DEF_SESSIONS_ENDPOINT = 'boby-ws2-ea-def-sessions';
export const DEF_LOGIN_ENDPOINT = 'boby-ws2-ea-def-login';

/** One `WS2_EA_DEF_LOGIN` row. */
export interface ExtranetDefLoginRow {
  NOM_PER: string | null;
  PRENOM_PER: string | null;
  ID_PER: number;
  SUPERVUE: string | null;
  EXTRANET_RECETTE: string | null;
  VEOS: string | null;
  NOM_PER_SESSION: string | null;
  PRENOM_PER_SESSION: string | null;
  ID_PER_SESSION: number;
}

/** The person of the active session carried by a `WS2_EA_DEF_LOGIN` row. */
export function sessionPersonOf(row: ExtranetDefLoginRow): ExtranetPerson {
  return {
    id: row.ID_PER_SESSION,
    nom: row.NOM_PER_SESSION,
    prenom: row.PRENOM_PER_SESSION,
  };
}

export const sessionService = {
  /** Sessions selectable by a SUPERVUE user, in API order. */
  async fetchSessions(registrySlug: string | null | undefined): Promise<ErpSession[]> {
    const rows = await fetchErpRows<ErpSession>(registrySlug, DEF_SESSIONS_ENDPOINT);
    return rows.filter((row) => typeof row.session === 'number');
  },

  /** The `WS2_EA_DEF_LOGIN` row for the current `SES`, or `null`. */
  async fetchDefLogin(
    registrySlug: string | null | undefined,
  ): Promise<ExtranetDefLoginRow | null> {
    return fetchErpRecord<ExtranetDefLoginRow>(registrySlug, DEF_LOGIN_ENDPOINT);
  },
};
